import "./MessageModals.scss";
import DeleteGif from "./../../assets/images/delete-gif.gif";
import CloseIcon from "./../../assets/images/close-icon.svg";
import { Modal } from "@mui/material";
import api from "./../../utils/api";
import { useState } from "react";
import GreenButton from "../GreenButton/GreenButton";
import { toast } from "react-toastify";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../context/LanguageContext";

const MessageModals = ({
  open,
  currentView,
  onClose,
  route,
  onDataChange,
  deleteMessage,
}) => {
  const { t } = useLanguage();
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    setLoading(true);
    try {
      await api.delete(`${route}`);
      await logout();
      toast.success(deleteMessage || "تم حذف المستخدم بنجاح");
      navigate("/");
      onDataChange();
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
      onClose();
    }
  };

  const renderDeleteView = () => (
    <div className="container">
      <div className="header" onClick={onClose}>
        <img src={CloseIcon} alt="" />
      </div>
      <div className="body">
        <img src={DeleteGif} alt="" />
        <h4>{t("deleteAccount")}</h4>
      </div>
      <div className="footer">
        <GreenButton
          text="حذف"
          onClick={handleDelete}
          size="medium"
          variant="fill"
          loading={loading}
        />
      </div>
    </div>
  );

  const renderDefaultView = () => (
    <div className="container">
      <div className="header" onClick={onClose}>
        <img src={CloseIcon} alt="" />
      </div>
      <div className="body">
        <h4>Default View</h4>
        <p>No specific view was selected.</p>
      </div>
      <div className="footer">
        <GreenButton
          text="Close"
          onClick={onClose}
          size="medium"
          variant="fill"
        />
      </div>
    </div>
  );

  const views = {
    delete: renderDeleteView,
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className="message-modal"
    >
      {(views[currentView] || renderDefaultView)()}
    </Modal>
  );
};

export default MessageModals;
